var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"tut-slide-up","appear":""}},[(
      !_vm.showGlobalModal &&
      _vm.tutActiveStep === _vm.TUTORIAL_STEPS_TYPES.HIGHLIGHT_SWAP &&
      _vm.tutStatus === _vm.TUTORIAL_STATUS_TYPES.STARTED
    )?_c('div',{staticClass:"interest-pointer-wrapper"},[_c('div',{staticClass:"interest-tooltip-wrapper"},[_c('BaseTooltip',{attrs:{"variant":"dark"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('tutorial_contextual_desc_interested_choice'))}})])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }